<template>
  <div v-if="showDiscountDisclaimer"
       class="card border-0 card-shadow rounded d-flex align-items-center justify-content-between flex-row py-2 py-lg-3 px-3 mb-4">
    <div class="d-flex align-items-lg-center">
      <Icon icon-name="iute-pepper-outline" class="text-primary mt-0 ml-n1 mr-3"></Icon>
      <div class="font-weight-bold">
        <div>{{ $t('LoanFormPage.signYourself') }}</div>
        <div>
          {{ $t('LoanFormPage.campaignDiscount') }}
          <span class="text-danger">{{ $n(customerBenefit, 'currency') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Icon from '@shared/components/Icon'

export default {
  components: { Icon },
  props: ['customerBenefit'],
  computed: {
    showDiscountDisclaimer() {
      return !!this.customerBenefit
    }
  }
}
</script>
